import * as React from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Select,
  Typography,
  InputLabel,
  FormControl,
  MenuItem,
  TextField,
} from "@mui/material";
import { updateTransactionRes } from "../services/httpCalls";
import useNotify from "../utils/useNotify";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "550px",
  height: "auto",
  bgcolor: "background.paper",
  borderRadius: "10px",

  boxShadow: 24,
};
const dropReason = [
  {
    name: "Transaction type not supported",
    value: "TRANSACTION_TYPE_NOT_SUPPORTED",
  },
  {
    name: "Customer requested to drop",
    value: "CUSTOMER_REQUESTED_TO_DROP",
  },
  {
    name: "Bank rejected",
    value: "BANK_REJECTED",
  },
  {
    name: "CA rejected",
    value: "CA_REJECTED",
  },
  {
    name: "Customer not valid",
    value: "CUSTOMER_NOT_VALID",
  },
  {
    name: "Others",
    value: "OTHER",
  },
];
function DroppedStage({
  setShowDroppedTxnModal,
  showDroppedTxnModal,
  setUpdateForm,
  updateForm,
  transactionId,
}) {
  const [reasonToDrop, setReasonToDrop] = React.useState("");
  const [reasonDescp, setReasonDescp] = React.useState("");
  let dropData = {
    dropReasonDescription: null,
    dropReasonGroup: null,
    nextStage: updateForm.nextStage,
  };
  let notify = useNotify();
  const navigate = useNavigate();
  const handleClose = () => {
    setUpdateForm({ ...updateForm, nextStage: null });
    setShowDroppedTxnModal(false);
    setReasonToDrop("");
    setReasonDescp("");
  };
  const updateDropReason = async () => {
    dropData.dropReasonGroup = reasonToDrop;
    dropData.dropReasonDescription = reasonDescp;

    await updateTransactionRes(dropData, transactionId)
      .then(async (res) => {
        notify.success("Transaction has been Dropped");
        await setShowDroppedTxnModal(false);
        await setReasonToDrop("");
        await setReasonDescp("");
        navigate("/");
      })
      .catch((err) => {
        notify.error("Not able to Drop Transaction");
        console.log(err);
      });
  };
  return (
    <div>
      <Modal open={showDroppedTxnModal} onClose={handleClose}>
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
              p: 1,
            }}
          >
            <Typography
              sx={{
                marginLeft: "20px",
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              component="h2"
            >
              Reason to Drop Transaction
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box p={2}>
            <Box>
              <FormControl
                sx={{
                  width: "500px",
                }}
              >
                <InputLabel>Reasons</InputLabel>
                <Select
                  label="Reasons"
                  id="reason_group"
                  name="reason_select"
                  value={reasonToDrop}
                  onChange={(e) => {
                    setReasonToDrop(e.target.value);

                    setUpdateForm({
                      ...updateForm,
                      drop_reason_group: e.target.value,
                    });
                  }}
                  required
                >
                  {dropReason?.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.value}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
            <Box mt={4} mb={2}>
              <FormControl>
                <TextField
                  label="Reason Description"
                  id="reason_desc"
                  name="reason_description"
                  placeholder="Please write Description for Rejecting"
                  multiline
                  value={reasonDescp}
                  rows={3}
                  color="primary"
                  sx={{
                    width: "500px",
                  }}
                  required
                  onChange={(e) => {
                    setReasonDescp(e.target.value);
                    setUpdateForm({
                      ...updateForm,
                      reason_description: e.target.value,
                    });
                  }}
                />
              </FormControl>
            </Box>
            <Box>
              <Button
                variant="contained"
                onClick={updateDropReason}
                disabled={
                  reasonDescp.length === 0
                    ? true
                    : false && reasonToDrop.length === 0
                    ? true
                    : false
                }
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
export default React.memo(DroppedStage);
